var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.6001 40.7001C45.1001 50.2001 51.0001 53.6001 51.0001 53.6001L54.5001 50.1001C57.3001 47.3001 62 47.3001 64.8 50.1001L72.5001 57.8002C75.3001 60.6002 75.3001 65.3001 72.5001 68.1001L69.1 71.5001C66.2 74.4001 62.0001 75.3002 58.2001 73.9002C51.0001 71.2002 38.6 65.1002 24.9 51.4002C11.2 37.7002 5.10005 25.3001 2.40005 18.1001C1.00005 14.3001 1.90004 10.1001 4.80004 7.2001L8.20007 3.8002C11.0001 1.0002 15.7001 1.0002 18.5001 3.8002L26.2001 11.5001C29.0001 14.3001 29.0001 19.0002 26.2001 21.8002L22.7001 25.3002C22.7001 25.3002 26.1001 31.3001 35.6001 40.7001Z",
    stroke: "#FF5800",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.a173709405fe58aa935a55b173c141a2.svg";
export { ForwardRef as ReactComponent };